var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBike = function SvgBike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.333 5.417a2.916 2.916 0 1 0 0 5.832 2.916 2.916 0 0 0 0-5.833Zm-.294 2.622a.417.417 0 1 1 .59.589.417.417 0 0 1-.59-.59Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.525 12.098c.346.054.654.25.848.542l2.963 4.444h4.33a1.25 1.25 0 0 1 0 2.5h-5a1.25 1.25 0 0 1-1.04-.557L23.05 15.16l-6.179 4.943 4.013 4.012c.234.235.366.553.366.884v6.667a1.25 1.25 0 1 1-2.5 0v-6.15l-4.634-4.633a1.25 1.25 0 0 1 .103-1.86l8.333-6.667a1.25 1.25 0 0 1 .973-.259Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.333 23.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5Zm-2.651 3.598a3.75 3.75 0 1 1 5.303 5.304 3.75 3.75 0 0 1-5.303-5.304ZM31.667 23.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5Zm-2.652 3.598a3.75 3.75 0 1 1 5.303 5.304 3.75 3.75 0 0 1-5.303-5.304Z",
    clipRule: "evenodd"
  })));
};
export default SvgBike;